<div class="adicional-modalidade flex flex-col mt-15" [class.estilo-projecao]="estiloProjecao">
  <div class="flex justify-between items-center mb-6">
    <h1 class="text-heading-lg m-0"
        [ngClass]="estiloProjecao ? 'text-blue-600 font-bold' : 'titulo-cinza text-semibold'">
      Adicional para modalidades e contextos
    </h1>
    <img *ngIf="downloadClick.observed" src="assets/icons/download.svg" alt="Download" class="download-icon w-4 h-4 me-6 cursor-pointer" (click)="downloadClick.emit()">
  </div>

  <div class="tabela-wrapper rounded-sm sm-shadow">
    <table class="tabela-adicional">
      <thead>
        <tr>
          <th class="text-start">Item</th>
          <th class="text-end">Número de matrículas</th>
          <th class="text-end">Valor adicionado no orçamento necessário (R$)</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let l of linhas">
          <td class="text-start">{{ l.item }}<sup *ngIf="l.nota">({{ l.nota }})</sup></td>
          <td class="text-end">{{ l.matriculas | number:'1.0-0':'pt' }}</td>
          <td class="text-end">{{ l.valor | number:'1.0-0':'pt' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <ol class="notas">
    <li>Considera as matrículas da Educação Profissional integradas e concomitantes ao Ensino Médio e à EJA identificadas no Censo Escolar.</li>
    <li>Considera as matrículas do Público de Educação Especial (PEE) identificadas no Censo Escolar.</li>
  </ol>
</div>
